import { useContext } from 'react'

import { RootContext } from '../root'

export const useFeatures = () => {
  const { features } = useContext(RootContext)

  const featureFlags = {
    isAccIntegrationEnabled: !!features.includes('accIntegration'),
    isDataElementsAndRulesTabsEnabled: !!features.includes('dataElementsAndRulesTabs'),
    isDecisioningSurfacesTabEnabled: !!features.includes('decisioningSurfacesTab'),
    isOxygenAuthoringRedirectionEnabled: !!features.includes('oxygenAuthoringRedirection'),
  }

  return { features, ...featureFlags }
}
